const map = {
	"./admin.json": 4709,
	"./auth.json": 200,
	"./automations.json": 2878,
	"./canned.json": 723,
	"./claude.json": 7712,
	"./common.json": 3251,
	"./customers.json": 179,
	"./dashboard.json": 9222,
	"./errors.json": 4513,
	"./globalSearch.json": 4701,
	"./kb.json": 1307,
	"./layout.json": 1604,
	"./mailbox.json": 5402,
	"./meetings.json": 5236,
	"./notifications.json": 7218,
	"./portal.json": 2656,
	"./privacy.json": 5790,
	"./profile.json": 3103,
	"./projectCsv.json": 1801,
	"./projectDetail.json": 7190,
	"./projectTemplates.json": 2746,
	"./projectView.json": 666,
	"./projects.json": 5800,
	"./reports.json": 1829,
	"./rules.json": 9857,
	"./slaSettings.json": 6901,
	"./tags.json": 8939,
	"./tickets.json": 871
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1215;